import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-nav-arrow",
  "use": "icon-nav-arrow-usage",
  "viewBox": "0 0 14 15",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 15\" fill=\"none\" id=\"icon-nav-arrow\">\n  <path d=\"M3.06348 5.53125L7.00098 9.46875L10.9385 5.53125\" stroke-width=\"1.00189\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol